module.exports = __webpack_public_path__ + "static/img/expr_img_append_2.a59da7a2.png";